import React, { useEffect } from "react";
import {
  AccordionProps,
  AccordionSummaryProps,
  styled,
} from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";

interface CustomAccordionProps {
  summary: React.ReactNode;
  content: React.ReactNode;
  expanded: boolean;
  onChange: (event: React.SyntheticEvent, expanded: boolean) => void;
}

export const Accordion: React.FC<CustomAccordionProps> = ({
  summary,
  content,
  expanded,
  onChange,
}) => {
  useEffect(() => {
    // Optional side effect on expansion
  }, [expanded]);

  return (
    <AccordionWrapper expanded={expanded} onChange={onChange}>
      <AccordionSummary>{summary}</AccordionSummary>
      <AccordionDetails>{content}</AccordionDetails>
    </AccordionWrapper>
  );
};

const AccordionWrapper = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  borderRadius: "8px",
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem", fontWeight: 900 }} />
    }
    {...props}
  />
))(() => ({
  backgroundColor: "#F6F8F9",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: 2,
  },
  border: "1px solid #E4E7EC",
  borderRadius: "8px",
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  padding: 2,
}));